<template>
  <div id="memberDetail">
    <v-card
      class="mx-auto my-3"
      color="#e6e6fa"
    >
      <v-simple-table>
        <template v-slot:default class="user-table-inner">
          <!-- <thead>
            <tr>
              <th class="text-center table-header resistance-color">レジスタンス</th>
              <th class="text-center table-header spy-color">スパイ</th>
            </tr>
          </thead> -->
          <tbody>
            <tr v-if="users.length>4 && users.length<7">
              <td class="text-center table-header resistance-color" style="color:#FFF"><b>レジスタンス</b></td>
              <td class="resistance-color-light"><b>{{ resistanceNum }}</b></td>
              <td class="spy-color-light"><b>{{ spyNum }}</b></td>
              <td class="text-center table-header spy-color" style="color:#FFF"><b>スパイ</b></td>
            </tr>
            <tr v-else>
              <td colspan="4">遊べる人数は5人以上，10人以下です．</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
  </div>
</template>
<script>
export default {
  name: 'memberDetail',
  data(){
    return {
      headers: [
        {text: "レジスタンス", value: "resistance", width: "200px", fixed: true},
        {text: "スパイ", value: "spy", width: "200px", fixed: true},
      ]
    }
  },
  computed: {
    users: function() {
      return this.$store.state.userList.users
    },
    resistanceNum() {
      var number = 0
      if (this.users.length > 8){
        number = 6
      }else if (this.users.length > 7){
        number = 5
      }else if (this.users.length > 5){
        number = 4
      }else if (this.users.length > 4){
        number = 3
      }
      return number
    },
    spyNum() {
      var number = 0
      if (this.users.length > 9){
        number = 4
      }else if (this.users.length > 6){
        number = 3
      }else if (this.users.length > 4){
        number = 2
      }
      return number
    }
  },
}
</script>
<style>
#memberDetail .table-header{
  width: 200px;
  font-size: 16px;
  border-bottom-width: 0px;
}
#memberDetail .resistance-color {
  /* background-color: #0000CD */
  background-color: #6060E0
}
#memberDetail .spy-color {
  /* background-color: #DC143C; */
  background-color: #C02020;
}
#memberDetail .resistance-color-light {
  color: #0000CD
}
#memberDetail .spy-color-light {
  color: #DC143C;
}
#memberDetail th {
  color: white;
  background-color: #222288;
  font-size: 16px;
}
#memberDetail td {
  background-color: #F5F5F5;
  font-size: 16px;
}
</style>
